import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=fcbf71b0&scoped=true&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"
import style0 from "./turnstile.vue?vue&type=style&index=0&id=fcbf71b0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf71b0",
  null
  
)

export default component.exports